
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1356',
  depVersions: {
  "customer-portal-app": "static-1.1356",
  "apollo-dlb": "static-3.73",
  "client-types": "static-1.436",
  "data-fetching-client": "static-1.9297",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.345",
  "growth-payments-core": "static-1.24256",
  "head-dlb": "static-1.4465",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5208",
  "hs-test-utils": "static-1.7609",
  "hub-http": "static-1.5820",
  "hub-http-shared-msw-handlers": "static-1.9064",
  "hubspot-dlb": "static-2.1762",
  "hubspot-prosemirror": "static-1.17168",
  "hubspot-url-utils": "static-1.3810",
  "HubStyleTokens": "static-2.11060",
  "I18n": "static-7.1520",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6077",
  "payment-link-components": "static-1.22486",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6477",
  "quartz-core": "static-1.5696",
  "react": "static-7.151",
  "react-colorpicker": "static-2.9840",
  "react-dlb": "static-1.67",
  "react-utils": "static-2.5015",
  "rich-text-lib": "static-1.19179",
  "transmute": "static-2.77",
  "ui-addon-upgrades": "static-9.17327",
  "ui-components-test-utils": "static-1.5198",
  "UIComponents": "static-3.8007",
  "foundations-assets": "static-1.4453",
  "foundations-components": "static-1.7176",
  "foundations-theming": "static-1.4028",
  "foundations-theming-specialty": "static-1.1744",
  "framer-motion": "static-1.61",
  "history": "static-4.47",
  "metrics-js": "static-1.9277",
  "PortalIdParser": "static-2.319",
  "portals-platform-lib": "static-1.335",
  "quartz-config": "static-1.255",
  "quick-fetch": "static-1.3584",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16267",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7768",
  "styled-components": "static-2.64",
  "tanstack-table": "static-1.23",
  "ui-addon-draggable": "static-3.4390",
  "ui-addon-react-router-dom": "static-1.9182",
  "usage-tracker": "static-1.6981",
  "usage-tracker-anonymous": "static-1.5398",
  "usage-tracker-core": "static-1.6831",
  "apollo-stack-hubspot": "static-3.69",
  "hs-promise-rejection-tracking": "static-1.4918",
  "raven": "static-3.5386",
  "raven-hubspot": "static-1.5693",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.16",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3082",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2754",
  "quartz-webpack": "static-1.2701",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.75",
  "commerce-analytics-service-client": "static-1.3307",
  "customer-data-objects": "static-1.7252",
  "frontend-preferences-client": "static-1.7564",
  "laboratory-lib": "static-3.6763",
  "onboarding-scopes": "static-1.6085",
  "rpc-client-utils": "static-1.4247",
  "ui-addon-opt": "static-4.8036",
  "HeadJS": "static-2.672",
  "hs-test-utils-bend-plugin": "static-1.2720",
  "msw": "static-1.39",
  "testing-library": "static-1.144",
  "ts-schema": "static-1.3761",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7224",
  "cssUtils": "static-1.675",
  "customer-data-ui-utilities": "static-1.9452",
  "HubStyle": "static-2.11368",
  "knowledge-content-types": "static-1.8253",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.152",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.481",
  "ui-addon-emoji-picker": "static-1.9513",
  "ui-addon-i18n": "static-1.10743",
  "ui-business-units-lib": "static-1.8631",
  "ui-shepherd-react": "static-3.9763",
  "video-components-external": "static-1.10084",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.3954",
  "commerce-tours-lib": "static-1.5454",
  "customer-data-properties": "static-1.50298",
  "getting-started-shared-tasks": "static-1.17404",
  "growth-onboarding-reliability": "static-1.4732",
  "onboarding-tours": "static-1.16035",
  "reference-resolvers-lite": "static-1.7714",
  "sales-checkout-service-client": "static-1.3319",
  "ui-addon-iframeable": "static-1.8627",
  "user-context": "static-1.4728",
  "dispatcher": "static-1.128",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.751",
  "hubspotter-http": "static-1.4313",
  "icons": "static-2.601",
  "mobile-manifest-mixins": "static-1.445",
  "quartz-auth": "static-1.152",
  "quartz-head": "static-1.142",
  "quartz-test": "static-1.152",
  "ui-fonts": "static-1.337",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9053",
  "data-token-picker": "static-1.15784",
  "FileManagerLib": "static-1.38063",
  "property-translator": "static-1.5037",
  "atom": "static-1.4718",
  "feature-store-service-types": "static-1.4173",
  "growth-monetization-service-types": "static-1.4180",
  "merchandise-lib": "static-1.253",
  "purchase-motions-components": "static-1.5202",
  "salesImages": "static-1.517",
  "self-service-api": "static-1.9848",
  "SharedI18nStrings": "static-1.179",
  "upgrade-management-service-types": "static-1.4164",
  "foundations-components-test-utils": "static-1.4659",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.90",
  "ui-images": "static-2.1034",
  "bend-plugin-foundations-components": "static-1.3445",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.57",
  "trellis-assets": "static-1.881",
  "bend-plugin-foundations-theming": "static-1.2511",
  "foundations-theming-base": "static-1.3013",
  "stylex": "static-1.25",
  "js-cookie": "static-1.18",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4099",
  "react-flip-move": "static-1.63",
  "bender-build-tools": "static-1.2754",
  "inbound-db-properties-service-client": "static-1.3537",
  "superstore": "static-1.4392",
  "feedback-loader": "static-1.28560",
  "ai-components-ui-library": "static-1.7923",
  "ui-addon-video-player": "static-1.8366",
  "ui-coaching-tips": "static-1.27485",
  "sassPrefix": "static-1.148",
  "react-dnd-compat": "static-1.4269",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2105",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7800",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4294",
  "content-media-composition-data-lib": "static-1.10725",
  "content-media-compositions": "static-2.14732",
  "idb-keyval": "static-1.37",
  "immer": "static-1.33",
  "immerable": "static-1.3775",
  "magpie-lib": "static-1.5216",
  "magpie-types": "static-1.4676",
  "media-bridge-lib": "static-1.18309",
  "video-data-lib": "static-1.33742",
  "commerce-products-lib": "static-1.8352",
  "crm-message-bus": "static-1.41911",
  "growth-data-modal": "static-1.4967",
  "hubspot-apollo-client": "static-1.4501",
  "onboarding-tours-client": "static-1.4249",
  "calling-global-api": "static-1.63126",
  "calling-internal-common": "static-1.30927",
  "calling-lifecycle-internal": "static-1.64508",
  "calling-lifecycle-messages": "static-1.56802",
  "conditional-properties-service-client": "static-1.3477",
  "crm-links": "static-1.5867",
  "customer-data-objects-ui-components": "static-1.12618",
  "customer-data-property-utils": "static-1.7686",
  "external-options-client-types": "static-1.3816",
  "file-manager-components": "static-1.22423",
  "framework-data-schema-resolvers": "static-1.6509",
  "google-libphonenumber": "static-1.31",
  "hs-entities": "static-1.269",
  "inbound-db-associations-writes-service-client": "static-1.2810",
  "inbound-db-meta-service-client": "static-1.3315",
  "inbounddb-objects-service-types": "static-1.3885",
  "meetings-icalendar-utils-lib": "static-1.253",
  "multi-currency-client-types": "static-1.3356",
  "object-builder-ui-client": "static-1.47447",
  "pipeline-validation-client-types": "static-1.3620",
  "property-value-citations": "static-1.912",
  "pulse": "static-1.123",
  "smart-property-lib": "static-1.5283",
  "tiered-pricing": "static-1.580",
  "ui-addon-form-validation": "static-1.10622",
  "growth-onboarding-confetti": "static-1.2678",
  "growth-onboarding-next-action-utils": "static-1.1104",
  "navigation-components": "static-1.16817",
  "onboarding-tours-utils": "static-1.101",
  "ui-shepherd-tracker": "static-1.7144",
  "ui-universal-auth": "static-1.8455",
  "batch-promise": "static-1.1172",
  "navigation-messaging": "static-1.6144",
  "getting-started-shared-tasks-store": "static-1.16522",
  "hubspotter-http-shared-msw-handlers": "static-1.9062",
  "audio-components": "static-1.5391",
  "FileManagerCore": "static-1.37922",
  "FileManagerImages": "static-1.35574",
  "video-components": "static-1.12087",
  "nav-client-types": "static-1.1953",
  "purchase-motions-api": "static-1.5205",
  "signup-constants": "static-1.18029",
  "signup-ui-url-generator": "static-2.7677",
  "trials-service-types": "static-1.3581",
  "chatspot-client-types": "static-1.10281",
  "chatspot-core": "static-1.19717",
  "ContentUtils": "static-1.67126",
  "copilot-toolkit": "static-1.10124",
  "growth-onboarding-feedback-components": "static-1.6209",
  "hls.js": "static-1.32",
  "reactive-lib": "static-1.349",
  "simple-logging-lib": "static-1.2673",
  "customer-data-tracking": "static-1.6503",
  "products-iframe-lib": "static-1.6914",
  "products-ui-components-shared-msw-handlers": "static-1.9446",
  "calling-error-reporting": "static-1.30933",
  "shared-worker-versioning": "static-1.10662",
  "calling-usage-tracker": "static-1.6184",
  "calling-orchestration-shared-library": "static-1.34307",
  "conversations-skeleton-state": "static-1.6895",
  "usage-tracker-container": "static-1.6971",
  "location-customization-utils-lib": "static-1.8067",
  "crm-pipelines-api-client-types": "static-1.3799",
  "framework-builder-read-service-client": "static-1.3684",
  "framework-data-schema-quick-fetch": "static-1.6414",
  "persist-promise": "static-1.3329",
  "directed-graph": "static-1.559",
  "event-emitter": "static-1.572",
  "breeze-intelligence-kit": "static-1.5076",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9147",
  "fsm": "static-1.3355",
  "policy-lib": "static-1.6431",
  "react-tinymce": "static-1.54175",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9210",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53301",
  "tinymce-plugins": "static-1.56415",
  "tinymce-themes": "static-1.55271",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4170",
  "video-embed": "static-1.34576",
  "content-icons-ui": "static-1.2090",
  "social-insights-client-types": "static-1.20964",
  "eligibility-engine-service-types": "static-1.2862",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4422",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.3915",
  "calling-orchestration-schema": "static-1.34532",
  "crm-record-cards-service-types": "static-1.3319",
  "highcharts": "static-8.97",
  "trellis-story-utils": "static-1.4150",
  "storybook-react": "static-1.25",
  "hub-http-contrib": "static-1.2693",
  "interframe": "static-3.4416",
  "tinymce-data": "static-1.39386",
  "ui-addon-sales-email": "static-1.4839",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11745",
  "layout-dnd-utils": "static-1.10720",
  "react-codemirror": "static-1.10248",
  "ui-brand-identity-lib": "static-1.13232",
  "NamespacedHubStyle": "static-2.8759",
  "outpost": "static-1.3862",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67201",
  "layout-data-lib": "static-1.9045",
  "browser-eslint": "static-2.57",
  "advanced-menus-core": "static-1.14559",
  "advanced-menus-lib": "static-1.11564",
  "ExportDialog": "static-6.10028",
  "ui-memberships-settings-lib": "static-1.32975",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14558",
  "ReduxMessenger": "static-2.10018",
  "simple-menus-lib": "static-1.16075"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1356",
  "apollo-dlb": "/apollo-dlb/static-3.73",
  "client-types": "/client-types/static-1.436",
  "data-fetching-client": "/data-fetching-client/static-1.9297",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.345",
  "growth-payments-core": "/growth-payments-core/static-1.24256",
  "head-dlb": "/head-dlb/static-1.4465",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5208",
  "hs-test-utils": "/hs-test-utils/static-1.7609",
  "hub-http": "/hub-http/static-1.5820",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9064",
  "hubspot-dlb": "/hubspot-dlb/static-2.1762",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17168",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3810",
  "HubStyleTokens": "/HubStyleTokens/static-2.11060",
  "I18n": "/I18n/static-7.1520",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6077",
  "payment-link-components": "/payment-link-components/static-1.22486",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6477",
  "quartz-core": "/quartz-core/static-1.5696",
  "react": "/react/static-7.151",
  "react-colorpicker": "/react-colorpicker/static-2.9840",
  "react-dlb": "/react-dlb/static-1.67",
  "react-utils": "/react-utils/static-2.5015",
  "rich-text-lib": "/rich-text-lib/static-1.19179",
  "transmute": "/transmute/static-2.77",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17327",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5198",
  "UIComponents": "/UIComponents/static-3.8007",
  "foundations-assets": "/foundations-assets/static-1.4453",
  "foundations-components": "/foundations-components/static-1.7176",
  "foundations-theming": "/foundations-theming/static-1.4028",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1744",
  "framer-motion": "/framer-motion/static-1.61",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9277",
  "PortalIdParser": "/PortalIdParser/static-2.319",
  "portals-platform-lib": "/portals-platform-lib/static-1.335",
  "quartz-config": "/quartz-config/static-1.255",
  "quick-fetch": "/quick-fetch/static-1.3584",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16267",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7768",
  "styled-components": "/styled-components/static-2.64",
  "tanstack-table": "/tanstack-table/static-1.23",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4390",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9182",
  "usage-tracker": "/usage-tracker/static-1.6981",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5398",
  "usage-tracker-core": "/usage-tracker-core/static-1.6831",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
  "raven": "/raven/static-3.5386",
  "raven-hubspot": "/raven-hubspot/static-1.5693",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.16",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3082",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2754",
  "quartz-webpack": "/quartz-webpack/static-1.2701",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.75",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3307",
  "customer-data-objects": "/customer-data-objects/static-1.7252",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7564",
  "laboratory-lib": "/laboratory-lib/static-3.6763",
  "onboarding-scopes": "/onboarding-scopes/static-1.6085",
  "rpc-client-utils": "/rpc-client-utils/static-1.4247",
  "ui-addon-opt": "/ui-addon-opt/static-4.8036",
  "HeadJS": "/HeadJS/static-2.672",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2720",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.144",
  "ts-schema": "/ts-schema/static-1.3761",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7224",
  "cssUtils": "/cssUtils/static-1.675",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9452",
  "HubStyle": "/HubStyle/static-2.11368",
  "knowledge-content-types": "/knowledge-content-types/static-1.8253",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.152",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9513",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10743",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8631",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9763",
  "video-components-external": "/video-components-external/static-1.10084",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.3954",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5454",
  "customer-data-properties": "/customer-data-properties/static-1.50298",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17404",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4732",
  "onboarding-tours": "/onboarding-tours/static-1.16035",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7714",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3319",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8627",
  "user-context": "/user-context/static-1.4728",
  "dispatcher": "/dispatcher/static-1.128",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.751",
  "hubspotter-http": "/hubspotter-http/static-1.4313",
  "icons": "/icons/static-2.601",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.445",
  "quartz-auth": "/quartz-auth/static-1.152",
  "quartz-head": "/quartz-head/static-1.142",
  "quartz-test": "/quartz-test/static-1.152",
  "ui-fonts": "/ui-fonts/static-1.337",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9053",
  "data-token-picker": "/data-token-picker/static-1.15784",
  "FileManagerLib": "/FileManagerLib/static-1.38063",
  "property-translator": "/property-translator/static-1.5037",
  "atom": "/atom/static-1.4718",
  "feature-store-service-types": "/feature-store-service-types/static-1.4173",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4180",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "purchase-motions-components": "/purchase-motions-components/static-1.5202",
  "salesImages": "/salesImages/static-1.517",
  "self-service-api": "/self-service-api/static-1.9848",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4164",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4659",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.90",
  "ui-images": "/ui-images/static-2.1034",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3445",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.57",
  "trellis-assets": "/trellis-assets/static-1.881",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2511",
  "foundations-theming-base": "/foundations-theming-base/static-1.3013",
  "stylex": "/stylex/static-1.25",
  "js-cookie": "/js-cookie/static-1.18",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4099",
  "react-flip-move": "/react-flip-move/static-1.63",
  "bender-build-tools": "/bender-build-tools/static-1.2754",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3537",
  "superstore": "/superstore/static-1.4392",
  "feedback-loader": "/feedback-loader/static-1.28560",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.7923",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8366",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27485",
  "sassPrefix": "/sassPrefix/static-1.148",
  "react-dnd-compat": "/react-dnd-compat/static-1.4269",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2105",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7800",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4294",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10725",
  "content-media-compositions": "/content-media-compositions/static-2.14732",
  "idb-keyval": "/idb-keyval/static-1.37",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3775",
  "magpie-lib": "/magpie-lib/static-1.5216",
  "magpie-types": "/magpie-types/static-1.4676",
  "media-bridge-lib": "/media-bridge-lib/static-1.18309",
  "video-data-lib": "/video-data-lib/static-1.33742",
  "commerce-products-lib": "/commerce-products-lib/static-1.8352",
  "crm-message-bus": "/crm-message-bus/static-1.41911",
  "growth-data-modal": "/growth-data-modal/static-1.4967",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4501",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4249",
  "calling-global-api": "/calling-global-api/static-1.63126",
  "calling-internal-common": "/calling-internal-common/static-1.30927",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64508",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56802",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3477",
  "crm-links": "/crm-links/static-1.5867",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12618",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7686",
  "external-options-client-types": "/external-options-client-types/static-1.3816",
  "file-manager-components": "/file-manager-components/static-1.22423",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6509",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "hs-entities": "/hs-entities/static-1.269",
  "inbound-db-associations-writes-service-client": "/inbound-db-associations-writes-service-client/static-1.2810",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3315",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3885",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.253",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3356",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47447",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3620",
  "property-value-citations": "/property-value-citations/static-1.912",
  "pulse": "/pulse/static-1.123",
  "smart-property-lib": "/smart-property-lib/static-1.5283",
  "tiered-pricing": "/tiered-pricing/static-1.580",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10622",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2678",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1104",
  "navigation-components": "/navigation-components/static-1.16817",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.101",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7144",
  "ui-universal-auth": "/ui-universal-auth/static-1.8455",
  "batch-promise": "/batch-promise/static-1.1172",
  "navigation-messaging": "/navigation-messaging/static-1.6144",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16522",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9062",
  "audio-components": "/audio-components/static-1.5391",
  "FileManagerCore": "/FileManagerCore/static-1.37922",
  "FileManagerImages": "/FileManagerImages/static-1.35574",
  "video-components": "/video-components/static-1.12087",
  "nav-client-types": "/nav-client-types/static-1.1953",
  "purchase-motions-api": "/purchase-motions-api/static-1.5205",
  "signup-constants": "/signup-constants/static-1.18029",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7677",
  "trials-service-types": "/trials-service-types/static-1.3581",
  "chatspot-client-types": "/chatspot-client-types/static-1.10281",
  "chatspot-core": "/chatspot-core/static-1.19717",
  "ContentUtils": "/ContentUtils/static-1.67126",
  "copilot-toolkit": "/copilot-toolkit/static-1.10124",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6209",
  "hls.js": "/hls.js/static-1.32",
  "reactive-lib": "/reactive-lib/static-1.349",
  "simple-logging-lib": "/simple-logging-lib/static-1.2673",
  "customer-data-tracking": "/customer-data-tracking/static-1.6503",
  "products-iframe-lib": "/products-iframe-lib/static-1.6914",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9446",
  "calling-error-reporting": "/calling-error-reporting/static-1.30933",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10662",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6184",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34307",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6895",
  "usage-tracker-container": "/usage-tracker-container/static-1.6971",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8067",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3799",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3684",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6414",
  "persist-promise": "/persist-promise/static-1.3329",
  "directed-graph": "/directed-graph/static-1.559",
  "event-emitter": "/event-emitter/static-1.572",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5076",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9147",
  "fsm": "/fsm/static-1.3355",
  "policy-lib": "/policy-lib/static-1.6431",
  "react-tinymce": "/react-tinymce/static-1.54175",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9210",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53301",
  "tinymce-plugins": "/tinymce-plugins/static-1.56415",
  "tinymce-themes": "/tinymce-themes/static-1.55271",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4170",
  "video-embed": "/video-embed/static-1.34576",
  "content-icons-ui": "/content-icons-ui/static-1.2090",
  "social-insights-client-types": "/social-insights-client-types/static-1.20964",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2862",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4422",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.3915",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34532",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3319",
  "highcharts": "/highcharts/static-8.97",
  "trellis-story-utils": "/trellis-story-utils/static-1.4150",
  "storybook-react": "/storybook-react/static-1.25",
  "hub-http-contrib": "/hub-http-contrib/static-1.2693",
  "interframe": "/interframe/static-3.4416",
  "tinymce-data": "/tinymce-data/static-1.39386",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4839",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11745",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10720",
  "react-codemirror": "/react-codemirror/static-1.10248",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13232",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8759",
  "outpost": "/outpost/static-1.3862",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67201",
  "layout-data-lib": "/layout-data-lib/static-1.9045",
  "browser-eslint": "/browser-eslint/static-2.57",
  "advanced-menus-core": "/advanced-menus-core/static-1.14559",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11564",
  "ExportDialog": "/ExportDialog/static-6.10028",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32975",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14558",
  "ReduxMessenger": "/ReduxMessenger/static-2.10018",
  "simple-menus-lib": "/simple-menus-lib/static-1.16075"
}
};
